import { useAuthStore } from '@/store/auth'
import { watch } from 'vue'

/**
 * Global auth-middleware
 *
 * Public / bypass logik:
 *  - Alltid publika: angivna publicPaths (login, startsida).
 *  - Bypass om query.pdf === '1' (används av server-side PDF export).
 *
 * OBS: Om du vill göra detta hårdare, byt ut pdf=1 mot en signerad token, se kommentar i PDF API.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const auth = useAuthStore()

  const protectedPrefixes = [
    '/orders',
    '/saved-carts',
    '/admin'
  ]

  // Endast skyddade paths kräver auth
  const isProtected = protectedPrefixes.some(prefix => to.path.startsWith(prefix))
  if (!isProtected) return

  // PDF export bypass (pdf=1)
  if (to.query?.pdf === '1') {
    return
  }

  // Server-side: gör inget (Firebase körs ej här)
  if (import.meta.server) return

  // Redan hydraterat? Ta beslut direkt.
  if (auth.hydrated) {
    if (!auth.isAuthenticated) {
      return navigateTo('/login?redirect=' + encodeURIComponent(to.fullPath))
    }
    return
  }

  // Vänta tills hydrated blir true
  await new Promise<void>((resolve) => {
    const stop = watch(
      () => auth.hydrated,
      (v) => { if (v) { stop(); resolve() } },
      { immediate: true }
    )
  })

  if (!auth.isAuthenticated) {
    return navigateTo('/login?redirect=' + encodeURIComponent(to.fullPath))
  }
})
